import React from "react";
import { Fragment, useState } from "react";
import { useEffect } from "react";
import { Image } from "../AbstractElements";
import { dynamicImage } from "../Utils";

export default function Loader() {
    const [show, setShow] = useState(true);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setShow(false);
        }, 3000);

        return () => {
            clearTimeout(timeout);
        };
    }, [show]);
    return (
        <Fragment>
            {show && (
                <div className="loader-wrapper">
                    <div className="theme-loader">
                        <div className="loader"></div>
                        <div className="loader-logo"><Image src={dynamicImage("landing/logo/footer-logo.png")} alt="" /></div>
                    </div>
                </div>
            )}
        </Fragment>
    );
}